import { atom } from 'recoil';

import { NotificationInstance } from 'antd/es/notification/interface';

export const notificationInstanceAtom = atom<NotificationInstance | null>({
  key: 'notificationInstanceAtom',
  default: null,
});
